import { useQuery } from 'hooks'
import { useEffect, useMemo, useState } from 'react'
import { fetchReconciliationLogs } from 'utils/api/logsApi'
import { calculateOffset } from 'utils/helpers/pagination'
import { getColumns } from './utils'
import DataTable from 'components/common/dataTable'
import { DataTablePagination } from 'components/common'
import { useLocation } from 'react-router-dom'
import { filterEmptyValues, FilterMeta } from 'utils/helpers'
import { FILTER_FIELD_RECONCILIATION_LOG } from './reconciliationLogFilterForm'

type Props = {
  onFilterMeta?: (filterMeta: FilterMeta) => void
}

const ReconciliationLogTable = ({ onFilterMeta }: Props) => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { getAllQueries } = useQuery()
  const { search } = useLocation()

  const columns = useMemo(() => getColumns(page), [page])

  const getLogs = async () => {
    try {
      const queries = getAllQueries()
      const filters = filterEmptyValues(
        queries[FILTER_FIELD_RECONCILIATION_LOG] || {},
      )

      const { data } = await fetchReconciliationLogs({
        limit: queries.limit || 10,
        page: queries.page || 1,
        filters,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
      if (data?.filterMeta) {
        onFilterMeta?.(data.filterMeta)
      }
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}
export default ReconciliationLogTable
